"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CashbackAndBonus = void 0;
var _mui = require("@ori-ui/mui");
var _i18n = require("@ori/i18n");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _types = require("../../types");
var _styles = require("../Summary/styles");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CashbackAndBonus = (param)=>{
    let { cashbackEarned, showBp, totalBp } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles2.Root, {
        "data-testid": getTestId(_types.TestId.CashbackAndBonus),
        children: [
            cashbackEarned ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Line, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        fontWeight: "bold",
                        children: formatMessage('toOriflameWallet')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles2.Earned, {
                        children: [
                            "+",
                            cashbackEarned
                        ]
                    })
                ]
            }) : null,
            showBp ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Line, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        fontWeight: "bold",
                        children: formatMessage('bonusPoints')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles2.Earned, {
                        children: [
                            "+",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
                                id: "bpCount",
                                values: {
                                    0: totalBp
                                }
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
};
exports.CashbackAndBonus = CashbackAndBonus;
